import { useState, useEffect } from 'react';
import '../../ConsignmentNote.css';
import axios from "axios";
import Global from "../../APIConfig";
import AuthUser from "../../AuthUser";
import { useLocation, useNavigate,useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Barcode from "../../Barcode";

function DrsPrint(){
    let navigate = useNavigate();
    const location = useLocation();
    const [isReadyToPrint, setIsReadyToPrint] = useState(false);
  const {slipno} = useParams();
  const { headers1, headers2, logout } = AuthUser();
  const [drsdata, setDrsdata] = useState([]);
  const [companyDetails, setCompanyDetails] = useState('');
   const [routecode, setRoutecode] = useState('No');
   const [hubname,setHubname] = useState('');
  const [messenger_name,setMessenger_name] = useState('');
  const [vehicle_number, setVehicle_number] = useState('');
  const [printlogo,setPrintlogo] = useState('');
  const [gDefaultCurrency,setGDefaultCurrency] = useState('$');
  const [drsdate ,setDrsdate] = useState('');



   useEffect(() => {
    if (location.state?.triggerPrint) {
      // Wait for render completion
      setIsReadyToPrint(true);
    }
  }, [location.state]);

  useEffect(() => {
  if (isReadyToPrint) {
    const timeout = setTimeout(() => {
         alert(
        "Before printing:\n\n" +
        "- Set layout to Landscape\n" +
        "- Set paper size to A4\n" +
        "- Set margins to None\n" +
        "Then press Print."
      );
      window.print();

      window.onafterprint = () => {
        navigate(-1); // or any path you want
      };
    }, 1000);

    return () => clearTimeout(timeout);
  }
}, [isReadyToPrint]);


    useEffect(() => {
      GetShipmentdata();
    }, []);
    const GetShipmentdata=()=>{
      axios({
          method: 'post',
          url: Global.baseUrl+'PrintDrs',
          headers:headers1,
          data: {
            drs_unique_id: slipno
          }
        })
        .then(function (response) {
          if(response.data.status == 200)
          {
              var data=response.data.value;
              setDrsdata(data);
              setCompanyDetails(data.companyDetails);
              setGDefaultCurrency(data.gDefaultCurrency);
              setHubname(response.data.hub_name);
              setMessenger_name(response.data.messenger_name);
              setVehicle_number(response.data.vehicle_number);
              setPrintlogo(response.data.printlogo);
              setRoutecode(data[0].routecode);
              setDrsdate(response.data.drsdate);

          }
        })
        .catch(function (error) {
          if(error.response.status==401){
              toast.error(error.response.statusText);
              logout();
              navigate('/');
              window.location.reload();
          }
          // console.log(error);
      });
    }
return(
    <div className="print-container container mt-3">
        <div className="row justify-content-between">
            <div className="col-12 col-md-3">
                <img src={`${Global.logoUrl}${printlogo}`} className="img-fluid" />
            </div>
            <div className="col-12 col-md text-center">
                <h2>Delivery Run Sheet</h2>
                <div className="d-flex justify-content-center">
                    <div className="p-1">Delivery Date: {drsdate}</div>
                    {/* <div className="p-1">HUB Code: MUMB01</div> */}
                    <div className="p-1"></div>
                </div>
            </div>
            <div className="col-12 col-md-3 text-end">
                <Barcode value={slipno} />
            </div>
        </div>
        <div className="row mt-3 justify-content-between">
            <div className="col-12 col-md-4">
                Delivery Hub Name: {hubname}
                <br />
                Route Code: {routecode}
            </div>
            <div className="col-12 col-md-4 text-end">
                Delivery Person Name: {messenger_name}
                <br />
                Vehicle Reg No.: {vehicle_number}
            </div>
        </div>
        <div className="row mt-3 justify-content-between table-responsive-sm" style={{ overflowX: 'auto' }}>
            <table className="table table-bordered border-dark border-2">
                <thead>
                <tr>
                    <th>Sr No</th>
                    <th>AWB #</th>
                    <th>Sender</th>
                    <th>Receiver</th>
                    {/* <th>Goods</th> */}
                    {/* <th>Date</th>
                    <th>Time</th> */}
                    {/* <th>COD</th> */}
                    {/* <th>Total<br/> Price</th> */}
                    {/* <th>NDR Reason</th> */}
                    <th>Receiver Signature</th>
                </tr>
                </thead>
                <tbody>
                    {drsdata.map((drs,i)=>{
                        return(
                            <tr>
                                <td key={i}>{i+1}</td>
                                <td> <Barcode value={Number(drs.slip_no)} /></td>
                                <td>
                                    <h6>{drs.sender_name}</h6>
                                    <p>{drs.sender_name}, {drs.sendercity}, {drs.sendercountry}</p>
                                    <p>Mob: {drs.sender_phone}</p>
                                </td>
                                <td>
                                    <h6>{drs.reciever_name}</h6>
                                    <p>{drs.reciever_name}, {drs.receivercity}, {drs.receivercountry}</p>
                                    <p>Mob: {drs.reciever_phone}</p>
                                    {drs.booking_mode ==='COD'&&
                                    <>
                                    <h6>Mode: {drs.booking_mode}</h6>
                                    <h4>Price: {gDefaultCurrency}{drs.total_amt}</h4>
                                    </>
                                    }
                                </td>
                                {/* <td>{drs.status_describtion}</td> */}
                                {/* <td>{gDefaultCurrency}{drs.total_cod_amt}</td>
                                <td>{gDefaultCurrency}{drs.total_amt}</td> */}
                                {/* <td></td> */}
                                <td>
                                    <table>
                                        <tr>
                                            <td>Name:</td>
                                            <td>____________________________</td>
                                        </tr>
                                        <tr>
                                            <td>Relation:</td>
                                            <td>____________________________</td>
                                        </tr>
                                        <tr>
                                            <td>Phone No:</td>
                                            <td>____________________________</td>
                                        </tr>
                                        <tr>
                                            <td>Date:</td>
                                            <td>____________________________</td>
                                        </tr>
                                        <tr>
                                            <td>Timeo:</td>
                                            <td>____________________________</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        )
                    })}
                    
                    
                </tbody>
            </table>
        </div>
        <hr />
        <div className="mt-3">
            <div className="row">
                <div className="col-12 col-md-6 text-center">
                    <h6>Sender Signature</h6>
                    <p>____________________________</p>
                </div>
                <div className="col-12 col-md-6 text-center">
                    <h6>Driver Signature</h6>
                    <p>____________________________</p>
                </div>
            </div>
        </div>


    </div>
);
}

export default DrsPrint;